"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUndefined = exports.isArray = exports.enumValues = exports.notEmpty = void 0;
/**
 * Checks wheter a value is not null or undefined, and TypeScript will infer the correct type.
 * Useful for filtering an array where some elements might be empty
 */
function notEmpty(value) {
    return value !== null && value !== undefined;
}
exports.notEmpty = notEmpty;
/**
 * Returns the values of an enum as an array. Works for both string and number enums.
 * The typing may permit more arguments than just enums, but don't use it for that..
 *
 * @param enumm an enum. Can be a numeric enum or string enum.
 */
function enumValues(enumm) {
    const keys = Object.keys(enumm).filter(key => isNaN(Number(key)));
    return keys.map(key => enumm[key]);
}
exports.enumValues = enumValues;
/**
 * Check if object is array and provide typeguard
 * @param obj any object to test
 */
function isArray(obj) {
    return Array.isArray(obj);
}
exports.isArray = isArray;
/**
 * Type-safe check whether any value is undefined as in "truthy": not `undefined, null, ''`
 * Exception: 0 is not undefined.
 * @param value The value to check
 * @param includeArray Whether empty arrays should be counted as undefined
 */
function isUndefined(value, includeArray = false) {
    if (value === null || value === undefined)
        return true;
    if (includeArray && Array.isArray(value) && value.length === 0)
        return true;
    if (value === '')
        return true;
    if (value === 0)
        return false;
    return false;
}
exports.isUndefined = isUndefined;
